import { render, staticRenderFns } from "./ConfirmDeleteWebhook.vue?vue&type=template&id=645b8750&"
import script from "./ConfirmDeleteWebhook.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports